import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './TS_CollapsableContainerV2.scss';
import { ComponentSync } from '../../core/ComponentSync.js';
import { _className } from '../../utils/tools.js';
import { LL_H_C, LL_V_L } from '../Layouts/index.js';
import { exists, resolveContent } from '@nu-art/ts-common';
import { TS_Icons } from '@nu-art/ts-styles';
export class TS_CollapsableContainerV2 extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.collapsed = nextProps.collapsed ?? this.state?.collapsed ?? (nextProps.initialCollapsed ?? true);
        state.animated = !!nextProps.animated;
        state.className = nextProps.className;
        state.style = nextProps.style;
        state.id = nextProps.id;
        return state;
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.forceUpdate)
            return true;
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    //######################### Logic #########################
    toggleCollapse = (e) => {
        const currentCollapsed = this.state.collapsed;
        if (exists(this.props.onCollapseToggle))
            return this.props.onCollapseToggle(currentCollapsed, e);
        this.setState({ collapsed: !currentCollapsed });
    };
    //######################### Render #########################
    render() {
        const className = _className('ts-collapsable-container-v2', this.state.collapsed && 'collapsed', this.state.animated && 'animated', this.state.className);
        return _jsxs(LL_V_L, { id: this.state.id, className: className, style: this.state.style, innerRef: this.props.innerRef, children: [this.render_Header(), this.render_Content()] });
    }
    render_Header() {
        return _jsxs(LL_H_C, { className: 'ts-collapsable-container-v2__header', onClick: this.toggleCollapse, onContextMenu: this.props.onHeaderRightClick, children: [this.render_Header_Caret(), _jsx("div", { className: 'ts-collapsable-container-v2__header-content', children: resolveContent(this.props.headerRenderer) })] });
    }
    render_Header_Caret = () => {
        if (!exists(this.props.customCaret))
            return _jsx(TS_Icons.treeCollapse.component, {});
        return resolveContent(this.props.customCaret);
    };
    render_Content() {
        return _jsx("div", { className: 'ts-collapsable-container-v2__content', children: _jsx("div", { className: 'ts-collapsable-container-v2__content-inner', children: resolveContent(this.props.containerRenderer) }) });
    }
}
//# sourceMappingURL=TS_CollapsableContainerV2.js.map